import { useState, useEffect, useCallback } from 'react';
import { fetchConductRiskInvestigationSummary } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';
import type { InvestigationSummary } from '../apiTypesConductRisk';

export interface UseConductRiskInvestigationSummaryResult {
  data:    InvestigationSummary | null;
  loading: boolean;
  error:   string | null;
  refetch: () => Promise<void>;
}

/** Carica la tabella di aggregazione evidenze Investigation (endpoint dedicato,
 *  non un componente/driver del report). Sola lettura. */
export function useConductRiskInvestigationSummary(
  reportId: string | undefined,
): UseConductRiskInvestigationSummaryResult {
  useAxiosInterceptor();
  const [data,    setData]    = useState<InvestigationSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!reportId) return;
    setLoading(true);
    setError(null);
    try {
      const summary = await fetchConductRiskInvestigationSummary(reportId);
      // Difensivo: normalizzo rows a [] se il BE restituisce null/undefined.
      setData({ ...summary, rows: summary.rows ?? [] });
    } catch (err: any) {
      console.error('Errore caricamento Investigation Summary:', err);
      setError(err?.message ?? 'Errore nel caricamento della tabella di riepilogo.');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
